<template>
  <el-date-picker
    v-model="date"
    class="order-page-date-picker"
    type="date"
    format="MMMM D, YYYY"
    popper-class="order-page-date-picker-dropdown"
    @change="$emit('change', date)"
  />
</template>

<script>
export default {
  emits: ["change"],
  props: {
    defaultDateString: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      date: new Date(this.defaultDateString)
    }
  },

  watch: {
    defaultDateString(newVal) {
      this.date = newVal;
    }
  }
}
</script>